const BASE_URL = `${import.meta.env.VITE_APP_API}`

export default BASE_URL
